let toDate = new Date();
toDate = toDate.toISOString();

let fromDate = new Date();
fromDate.setDate(fromDate.getDate()-14);
fromDate = fromDate.toISOString();

let initialState = {
    fetching:false,
    fetched: false,
    error: null,
    fromDate: fromDate,
    toDate: toDate,
    sensorId: 12,
    rollUp:'24h',
    functionId:'avg',
    sensorKey: 'temp',
    readings: ['0:initialStateDate,1:12']
}

export const scReducer = (state = initialState, action) => {
    switch (action.type) {
        case "FETCH_READINGS_START":
            state = {...state,
                fetching: true
            }
            break;
        case "FETCH_READINGS_ERROR":
            state = {...state,
                fetching: false,
                error: action.payload
            }
            break;
        case "RECEIVE_READINGS":
            state = {
                ...state,
                fetched: true,
                readings: action.payload.readings,
                sensorKey: action.payload.sensor_key
            }
            break;
        case "SET_FROM_DATE":
            state = {
                ...state,
                fromDate: action.payload,
            }
            break;
        case "SET_TO_DATE":
            state = {
                ...state,
                toDate: action.payload
            }
            break;
        case "SET_SENSOR":
            state = {
                ...state,
                sensorId: action.payload
            }
            break;
        case "SET_ROLLUP":
            state = {
                ...state,
                rollUp: action.payload
            }
            break;
        case "SET_FUNCTION":
            state = {
                ...state,
                functionId: action.payload
            }
            break;
        case "SET_SENSOR_KEY":
            state = {
                ...state,
                sensorKey: action.payload
            }
            break;
        default:
            return state;
    }

    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/scReducer.js